const Loader = () => {
  return (
    <div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh"
    }}>
      <h3>Loading...</h3>
    </div>
  );
};

export default Loader;
